// extracted by mini-css-extract-plugin
export var emptyState = "_5w-d";
export var statCard = "_5w-c";
export var table = "_5w-0";
export var tableCell = "_5w-4";
export var tableCellClickable = "_5w-5 _5w-4";
export var tableCellDefault = "_5w-6 _5w-4";
export var tableCellEmpty = "_5w-8";
export var tableCellWithValue = "_5w-7";
export var tableContainer = "_5w-e";
export var tableHeaderWeight = "_5w-1";
export var tableHeaderZone = "_5w-2";
export var tableRowHeader = "_5w-3";
export var viewModeButton = "_5w-9";
export var viewModeButtonActive = "_5w-a _5w-9";
export var viewModeButtonInactive = "_5w-b _5w-9";